import { memo } from "react";
import { type PdpPageProductData } from "~/features/productDetails/models/PdpPageProductData";
import EmptyCadTab from "~/features/productDetails/components/PdpTabs/CadTab/EmptyCadTab";
import ConfiguredCadTabV2 from "~/features/productDetails/components/PdpTabs/CadTab/ConfiguredCadTabV2";
import { ExternalBrand } from "~/domains/product/types/ProductDataDTO";
import { EwellixCadTab } from "~/features/productDetails/components/PdpTabs/CadTab/EwellixCadTab";

export interface CadTabProps {
  product: Pick<
    PdpPageProductData,
    | "designation"
    | "tracePartsOrderNo"
    | "tracePartsUrl"
    | "customerRequestedCADAvailability"
    | "code"
    | "externalBrand"
  >;
}

const CadTab = (props: CadTabProps) => {
  const isCADConfigured = !!props.product.tracePartsUrl;

  if (isCADConfigured) {
    if (props.product.externalBrand === ExternalBrand.Ewellix) {
      return <EwellixCadTab url={props.product.tracePartsUrl} />;
    } else {
      return <ConfiguredCadTabV2 {...props} />;
    }
  } else {
    return <EmptyCadTab {...props} />;
  }
};

export default memo(CadTab);
